'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Styles = require('./TargetDateSeries.css');

var TargetDateSeries = (_dec = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(TargetDateSeries, _Component);

  function TargetDateSeries() {
    (0, _classCallCheck3.default)(this, TargetDateSeries);
    return (0, _possibleConstructorReturn3.default)(this, (TargetDateSeries.__proto__ || (0, _getPrototypeOf2.default)(TargetDateSeries)).apply(this, arguments));
  }

  (0, _createClass3.default)(TargetDateSeries, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'main-grid' },
        _container2.default.helmet('Target date series', _config2.default.app.description, _config2.default.app.domain + _config2.default.routes.targetDateFunds),
        _react2.default.createElement(_components.TargetDateGrid, null)
      );
    }
  }]);
  return TargetDateSeries;
}(_react.Component)) || _class);
exports.default = TargetDateSeries;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/TargetDateSeries/TargetDateSeries.js
// module id = 1343
// module chunks = 0